import React from 'react';

const feedbacks = [
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/7lqquxil_image.png",
    name: "silva",
    text: "Do prata ao mestre full magnet"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/31h3c88e_image.png",
    name: "SilvaZx",
    text: "so vem bb"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/clg1bv7p_image.png",
    name: "Player",
    text: "Mestre de Honra com o painel"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/yotev13l_image.png",
    name: "jpzz.ks",
    text: "Slk o melhor 01"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/qh9eknio_image.png",
    name: "Fori",
    text: "Desafiante no CS Ranqueado"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/7chj8dhz_image.png",
    name: "Cris apostados ff",
    text: "Cloud Cheats ja parou o cenario, monstro maravilhado"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/4i35q93u_image.png",
    name: "?? LEVEL",
    text: "Ta lindo ta maravilhoso esse painel"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/m0ifyzwp_image.png",
    name: "fael_rsx",
    text: "Melhor painel bypass do momento +10 no bolso"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/cqy9xsgy_image.png",
    name: "VETIN",
    text: "MELHOR Q TEM N TEM JEITO!"
  },
  {
    image: "https://customer-assets.emergentagent.com/job_07e3fa1c-accb-40af-b9f6-b18f873b4bec/artifacts/q712fwyl_image.png",
    name: "pablinnn",
    text: "Ja falei que e top?"
  }
];

const Feedbacks = ({ isBrazil = true }) => {
  return (
    <section id="feedbacks-section" className="py-12 sm:py-16" data-testid="feedbacks-section">
      <h2 className="text-center text-white gaming-title text-2xl sm:text-3xl mb-2">
        {isBrazil ? 'RESULTADOS DOS CLIENTES' : 'CUSTOMER RESULTS'}
      </h2>
      <p className="text-center text-gray-400 text-sm mb-8">
        {isBrazil ? 'Veja o que nossos clientes estao conquistando' : 'See what our customers are achieving'}
      </p>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-6xl mx-auto px-4">
        {feedbacks.map((fb, idx) => (
          <div key={idx} className="bg-gray-900 rounded-xl border border-gray-800 overflow-hidden hover:border-red-900/50 transition-colors">
            <img
              src={fb.image}
              alt={fb.name}
              className="w-full h-auto object-cover"
              loading="lazy"
            />
            <div className="p-3 flex items-center gap-2">
              <div className="w-2 h-2 bg-green-500 rounded-full animate-pulse" />
              <span className="text-gray-300 text-sm font-semibold">{fb.name}</span>
              <span className="text-gray-500 text-xs">— "{fb.text}"</span>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Feedbacks;
